module.exports = require('./src/Scripts/jquery.fileDownload');



//////////////////
// WEBPACK FOOTER
// ./~/jquery-file-download/index.js
// module id = 211
// module chunks = 1 3 7 8